import React, { useEffect, useState, Suspense, lazy } from 'react';
import { createBrowserRouter, Link, Outlet, BrowserRouter as Router, RouterProvider } from 'react-router-dom';
import './styles/animation.css';
import './styles/BackToTop.css';
import './styles/sidebar.css';
import { Avatar, Badge, Button, Dropdown, Layout, Menu, Space, theme } from 'antd';
import { CustomToast } from './composants/toast/CustomToast';
import Background from './composants/background/background';
import { LoadingContext } from './composants/loadingContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faBookJournalWhills, faBuilding, faClockRotateLeft, faClose, faFemale, faHospital, faJournalWhills, faMapLocation, faPeopleGroup, faPersonPregnant, faSchool, faVirus } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { formatAuthor } from './composants/utils/utils';
import { faTypo3 } from '@fortawesome/free-brands-svg-icons';
import Loader from './composants/loader/Loader';
import ReloginModal from './components/login/ReloginModal';

// Lazy loaded components
const ListArticles = lazy(() => import('./components/articles/list/listArticles'));
const ReadArticles = lazy(() => import('./components/articles/read/readArticles'));
const CarteLeaflet = lazy(() => import('./components/carte/carteLeaflet'));
const Login = lazy(() => import('./components/login/login'));
const ForgetPassword = lazy(() => import('./components/forgetPassword/forgetPassword'));
const RendezVous = lazy(() => import('./page/rendezVous/rendez_vous'));
const Usraj = lazy(() => import('./page/usraj/usraj'));
const UsrajService = lazy(() => import('./page/usraj/usrajService'));
const TakeMeeting = lazy(() => import('./page/rendezVous/take_rendezVous'));
const AllMyUSRAJ = lazy(() => import('./page/usraj/manageUsraj'));
const Contact = lazy(() => import('./page/contact/contact'));
const Profile = lazy(() => import('./page/profile/profile'));
const ErrorPageTemplate = lazy(() => import('./page/error/404'));


function App() {
    const route = createBrowserRouter([
        {
            path: '/',
            errorElement: <SignIn />,
            children: [
                {
                    path: '',
                    element: <SignIn />
                },
                {
                    path: 'login',
                    element: <SignIn />
                },
                {
                    path: 'forget_password',
                    element: <ForgetPWD />
                },
                {
                    path: 'home',
                    element: <Root />,
                    children: [
                        {
                            path: 'meeting',
                            element: <RendezVous />
                        },
                        {
                            path: 'carte',
                            element: <CarteLeaflet />
                        },
                        {
                            path: 'contact',
                            element: <Contact />
                        },
                        {
                            path: 'profile',
                            element: <Profile />
                        },
                        // {
                        //     path: 'article',
                        //     children: [
                        //         {
                        //             path: ':name',
                        //             element: <ListArticles />
                        //         },
                        //         {
                        //             path: 'read/:id',
                        //             element: <ReadArticles />
                        //         },
                        //         {
                        //             path: '*',
                        //             element: <ErrorPageTemplate code={404} />
                        //         }
                        //     ]
                        // },
                        {
                            path: 'usraj',
                            children: [
                                {
                                    path: '',
                                    element: <Usraj />
                                },
                                {
                                    path: 'manage',
                                    element: <AllMyUSRAJ />
                                },
                                {
                                    path: 'services',
                                    children: [
                                        {
                                            path: ':id',
                                            children: [
                                                {
                                                    path: '',
                                                    element: <UsrajService />
                                                },
                                                {
                                                    path: 'take-meeting/:id',
                                                    element: <TakeMeeting />
                                                },
                                                {
                                                    path: '*',
                                                    element: <ErrorPageTemplate code={404} />
                                                }
                                            ]
                                        },

                                    ]
                                }
                            ]
                        },
                        {
                            path: '*',
                            element: <ErrorPageTemplate code={404} />
                        }
                    ]
                }
            ]
        }
    ]);
    function Root() {
        const [loading, setLoading] = useState(true);
        const { Header, Sider, Content, Footer } = Layout;
        const [collapsed, setCollapsed] = useState(false);
        const { user, droits } = useSelector(state => state.authUser);
        const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();
        const valueLoading = {
            loading: loading,
            setLoading: setLoading
        };
        useEffect(() => {
            if (!user || !droits || droits.length === 0) {
                window.location.href = '/login';
                return;
            }
        }, [user, droits]);
        const articleSubMenu = [
            {
                title: 'Santé Sexuelle et Reproductrice',
                code: 'SANTE_SEXUELLE',
                icon: faHospital,
                id: '6'
            },
            {
                title: 'Prévention des Grossésses Précoces',
                code: 'GROSSESSE_PRECOSE',
                icon: faPersonPregnant,
                id: '7'
            },
            {
                title: 'Hygiene Menstruelle',
                code: 'HYGENE_MENSTRUELLE',
                icon: faFemale,
                id: '8'
            },
            {
                title: 'IST & VIH/SIDA',
                code: 'VIH_IST',
                icon: faVirus,
                id: '9'
            },
            {
                title: 'Violences Basées sur le Genre',
                code: 'VVG',
                icon: faTypo3,
                id: '10'
            },
            {
                title: 'Avortements Sécurisée',
                code: 'IVG',
                icon: faPersonPregnant,
                id: '11'
            },
            {
                title: 'Planning Familiale / Contraception',
                code: 'PLANNING_FAMILLIAL',
                icon: faBookJournalWhills,
                id: '12'
            },
            {
                title: 'LeaderShip Jeune',
                code: 'YOUNGLEAD',
                icon: faPeopleGroup,
                id: '13'
            }
        ];
        function getItem(label, key, icon, children) {
            return {
                key,
                icon,
                children,
                label,
            };
        };
        const subMenu = () => {
            const menus = [];
            // articleSubMenu.map(menu =>{
            //     menus.push(getItem(<a href={'/home/article/'+menu.code} title={menu.title}>{menu.title}</a>, menu.id, <FontAwesomeIcon icon={menu.icon} />))
            // });
            return menus;
        }
        const items = [
            getItem(<Link to={'/home/meeting'} title='Mes rendez-vous'>Mes Rendez-vous</Link>, '1', <FontAwesomeIcon icon={faClockRotateLeft} />),
            getItem(<Link to={'/home/usraj'} title='Unite de Sante Reproductrice Ado Jeune'>USRAJ</Link>, '3', <FontAwesomeIcon icon={faHospital} />),
            getItem(<Link to={'/home/carte'} title='Localiser les Unitees de Sante Reproductrice Ado Jeune'>Localiser les USRAJ</Link>, '4', <FontAwesomeIcon icon={faMapLocation} />),
            (droits?.includes("UPDATE_USRAJ")) && getItem(<Link to="/home/usraj/manage" title='Mes USRAJ'>Mes USRAJ</Link>, '2', <FontAwesomeIcon icon={faBuilding} />),
            // getItem('Articles', '5', <FontAwesomeIcon icon={faJournalWhills} />,subMenu()),
            getItem(<Link to="https://e-learning.youthfp.cm/" title='E-Learning' target="_blank">E-Learning</Link>, '14', <FontAwesomeIcon icon={faSchool} />),
        ];
        const menuProps = {
            items: [
                {
                    label: (
                        <div className="ml-4" title={(user === null) ? "" : user?.prenom + ' ' + user?.nom}>
                            <div className="text-sm font-medium text-gray-900">
                                {(user === null) ? "" : formatAuthor(user?.nom.toUpperCase(), 5)}
                            </div>
                            <div className="text-sm text-gray-500">
                                {(user === null) ? "" : formatAuthor(user?.prenom, 5)}
                            </div>
                        </div>
                    ),
                    key: '0',
                },
                {
                    type: 'divider',
                },
                {
                    label: (
                        <Link rel="noopener noreferrer" to="/home/profile">
                            Profile
                        </Link>
                    ),
                    key: '1',
                },
                {
                    type: 'divider',
                },
                {
                    label: (
                        <Link rel="noopener noreferrer" to="/home/contact">
                            Nous Contacter
                        </Link>
                    ),
                    key: '3',
                },
                {
                    type: 'divider',
                },
                {
                    label: (
                        <p rel="noopener noreferrer" onClick={() => {
                            window.location.href = '/';
                        }}>
                            Deconnexion
                        </p>
                    ),
                    key: '4',
                },
            ],
        };

        return (
            <>
                {user == null ? <Loader /> :
                    <LoadingContext.Provider value={valueLoading}>
                        <Layout className="min-h-screen flex flex-col">
                            <Sider
                                trigger={null}
                                collapsible
                                collapsed={collapsed}
                                theme='light'
                                className="fixed h-screen overflow-auto left-0 top-0 bottom-0 shadow-xl border-r border-gray-200"
                                style={{
                                    background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
                                }}
                            >
                                {/* Logo Section */}
                                <div className="flex items-center justify-center py-6 px-4 border-b border-gray-200 bg-gradient-to-r from-blue-600 to-purple-600">
                                    {!collapsed ? (
                                        <img
                                            src='/images/logo/logo.png'
                                            className='h-16 transition-all duration-300 hover:scale-105'
                                            alt="YouthFP Logo"
                                        />
                                    ) : (
                                        <img
                                            src='/images/logo/justlogo.png'
                                            className='h-12 transition-all duration-300 hover:scale-110'
                                            alt="YouthFP"
                                        />
                                    )}
                                </div>

                                {/* User Info Card (only when not collapsed) */}


                                {/* Menu Items with custom styling */}
                                <div className="px-2">
                                    <Menu
                                        theme="light"
                                        defaultSelectedKeys={['1']}
                                        mode="inline"
                                        items={items}
                                        className="border-0 bg-transparent"
                                        style={{
                                            fontSize: collapsed ? '14px' : '15px',
                                        }}
                                    />
                                </div>

                                {/* Footer Info (only when not collapsed) */}

                            </Sider>
                            <Layout className={`transition-all duration-200 ${collapsed ? 'ml-20' : 'ml-52'}`}>
                                <Header className="sticky top-0 z-10 p-0 bg-white shadow-md border-b border-gray-200">
                                    <nav>
                                        <div className="flex flex-wrap items-center justify-between px-4 h-16">
                                            <div className="flex items-center space-x-4">
                                                <Button
                                                    type="text"
                                                    icon={collapsed ? <FontAwesomeIcon icon={faBars} /> : <FontAwesomeIcon icon={faClose} />}
                                                    onClick={() => setCollapsed(!collapsed)}
                                                    className="w-10 h-10 text-lg hover:bg-blue-50 rounded-lg transition-all duration-200"
                                                />
                                                <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent hidden md:block">
                                                    YouthFP
                                                </h1>
                                                {/* Financeur Badge */}
                                                <div className="hidden lg:flex items-center ml-6 px-4 py-2 bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg border border-blue-200 shadow-sm">
                                                    <span className="text-xs text-gray-600 mr-2">Financé par:</span>
                                                    <img
                                                        src="/images/pngegg.png"
                                                        alt="UNFPA Cameroun"
                                                        className="h-8 object-contain"
                                                        title="UNFPA Cameroun"
                                                    />
                                                </div>
                                            </div>
                                            <div className="flex items-center lg:order-2">
                                                <Dropdown menu={menuProps}>
                                                    <a onClick={e => e.preventDefault()}>
                                                        <Space className='px-3 py-2 hover:bg-gradient-to-r hover:from-blue-50 hover:to-purple-50 rounded-lg transition-all duration-200 cursor-pointer'>
                                                            <Badge dot style={{ backgroundColor: '#10b981' }}>
                                                                <Avatar
                                                                    size={40}
                                                                    src={user?.photo == null ? '/images/profile-img.jpg' : user?.photo}
                                                                    className="border-2 border-white shadow-md"
                                                                />
                                                            </Badge>
                                                            <div className="hidden lg:block">
                                                                <p className="text-sm font-bold text-gray-800">{user?.nom}</p>
                                                                <p className="text-xs text-gray-500">{user?.prenom}</p>
                                                            </div>
                                                            <svg className="hidden lg:block w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                            </svg>
                                                        </Space>
                                                    </a>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </nav>
                                </Header>
                                <Content className="min-h-[280px] rounded-lg py-6">
                                    <Background />
                                    <div className="flex-grow">
                                        <Outlet />
                                        <CustomToast />
                                        <ReloginModal />
                                    </div>
                                </Content>
                                <Footer className="text-center bg-gradient-to-r from-blue-50 to-purple-50 border-t border-gray-200 py-6">
                                    <div className="space-y-3">
                                        <div className="text-sm text-gray-600">
                                            YouthFP ©{new Date().getFullYear()} Created by AfriYAN Cameroun
                                        </div>
                                        <div className="flex items-center justify-center space-x-2">
                                            <span className="text-xs text-gray-500">Financé par:</span>
                                            <div className="px-4 py-2 bg-white rounded-lg shadow-md border border-blue-200">
                                                <span className="text-sm font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                                                    UNFPA Cameroun
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </Footer>
                            </Layout>
                        </Layout>
                    </LoadingContext.Provider>}
            </>
        );
    }

    function SignIn() {
        const [loading, setLoading] = useState(true);
        const valueLoading = {
            loading: loading,
            setLoading: setLoading
        }
        return (
            <LoadingContext.Provider value={valueLoading}>
                <Background />
                <Login />
            </LoadingContext.Provider>
        );
    }

    function ForgetPWD() {
        const [loading, setLoading] = useState(true);
        const valueLoading = {
            loading: loading,
            setLoading: setLoading
        }
        return (
            <LoadingContext.Provider value={valueLoading}>
                <Background />
                <ForgetPassword />
            </LoadingContext.Provider>
        );
    }

    return (
        <Suspense fallback={<Loader />}>
            <RouterProvider router={route} />
        </Suspense>
    );
}

export default App;
